/* =============================================================================
   TTS Clinical — carrito sin salir de la pagina.

   EL PROBLEMA QUE RESUELVE. Las 11 vias de "anadir" del sitio son anclas a un
   permalink /cart/<variante>:<cantidad>. Ese permalink hace dos cosas que el
   cliente no espera: REEMPLAZA el carrito en vez de sumar, y NAVEGA fuera de la
   pagina. Asi que anadir dos productos dejaba uno, y cada clic te sacaba del
   catalogo.

   LA SOLUCION. Un unico manejador delegado en document intercepta cualquier
   ancla cuyo href sea ese permalink y lo convierte en un POST a /cart/add.js,
   que SUMA. Delegado a proposito: el B2B y el constructor de regimen crean sus
   botones con JS despues de la carga, y asi entran solos sin registrar nada.

   NO se toca ninguna seccion. Si este archivo falla o no carga, las anclas
   siguen funcionando como antes (navegan al carrito): mejora progresiva, no
   sustitucion.

   EL DESCUENTO. La landing del Trifecta lleva ?discount=WELCOME en el
   permalink. /cart/add.js no sabe de descuentos, asi que despues de anadir se
   pide /discount/<codigo> en segundo plano, que es lo que fija la cookie de
   descuento del carrito. Si falla, el producto ya esta dentro: no se bloquea.
   ============================================================================= */
(function () {
  "use strict";

  var SOLO_PERMALINK = /^\/cart\/\d+:\d+(?:,\d+:\d+)*$/;

  function idioma() {
    return typeof window.ttsIdioma === "function" ? window.ttsIdioma() : "es";
  }

  var TEXTO = {
    es: { ok: "Añadido al carrito", ver: "Ver carrito", error: "No se pudo añadir" },
    en: { ok: "Added to cart",      ver: "View cart",   error: "Could not add" }
  };
  function t(k) { return (TEXTO[idioma()] || TEXTO.es)[k]; }

  /* ---- lectura del permalink ------------------------------------------- */
  function leer(a) {
    var href = a.getAttribute("href");
    if (!href) return null;
    var u;
    try { u = new URL(href, location.origin); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (!SOLO_PERMALINK.test(u.pathname)) return null;   /* /cart y /cart/ pasan de largo */

    var items = u.pathname.slice(6).split(",").map(function (par) {
      var p = par.split(":");
      return { id: parseInt(p[0], 10), quantity: parseInt(p[1], 10) || 1 };
    });
    if (items.some(function (i) { return !i.id || i.quantity < 1; })) return null;

    return { items: items, descuento: u.searchParams.get("discount") };
  }

  /* ---- contador de la cabecera ----------------------------------------- */
  function pintar(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(n);
      var enlace = el.closest(".cart-link");
      if (enlace) {
        enlace.classList.toggle("vacio", n === 0);
        enlace.classList.remove("late");
        /* reflow para poder repetir la animacion en clics seguidos */
        void enlace.offsetWidth;
        if (n > 0) enlace.classList.add("late");
      }
    });
  }

  function recontar() {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) { pintar(c.item_count); return c; });
  }

  /* ---- aviso ------------------------------------------------------------ */
  var aviso;
  function avisar(msg, esError) {
    if (!aviso) {
      aviso = document.createElement("div");
      aviso.className = "tts-aviso";
      aviso.setAttribute("role", "status");
      aviso.setAttribute("aria-live", "polite");
      document.body.appendChild(aviso);
    }
    aviso.textContent = "";
    var txt = document.createElement("span");
    txt.textContent = msg;
    aviso.appendChild(txt);
    if (!esError) {
      var ver = document.createElement("a");
      ver.href = "/cart";
      ver.className = "ir";
      ver.textContent = t("ver");
      aviso.appendChild(ver);
    }
    aviso.classList.toggle("error", !!esError);
    aviso.classList.add("visible");
    clearTimeout(avisar._t);
    avisar._t = setTimeout(function () { aviso.classList.remove("visible"); }, esError ? 5000 : 3500);
  }

  /* ---- anadir ----------------------------------------------------------- */
  function anadir(datos) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: datos.items })
    })
      .then(function (r) {
        return r.json().then(function (cuerpo) {
          if (!r.ok) throw new Error(cuerpo.description || cuerpo.message || t("error"));
          return cuerpo;
        });
      })
      .then(function () {
        if (!datos.descuento) return null;
        return fetch("/discount/" + encodeURIComponent(datos.descuento), {
          credentials: "same-origin"
        }).catch(function () { /* el producto ya esta dentro; el codigo se puede meter en el checkout */ });
      })
      .then(recontar);
  }

  /* ---- clic ------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest("a");
    if (!a || a.getAttribute("aria-disabled") === "true") return;
    var datos = leer(a);
    if (!datos) return;

    e.preventDefault();
    if (a.dataset.ttsCargando === "1") return;

    a.dataset.ttsCargando = "1";
    a.classList.add("cargando");

    anadir(datos)
      .then(function () { avisar(t("ok"), false); })
      .catch(function (err) { avisar(err.message || t("error"), true); })
      .then(function () {
        delete a.dataset.ttsCargando;
        a.classList.remove("cargando");
      });
  });

  /* El contador ya viene pintado por Liquid. Se recuenta al volver de una
     pagina servida desde cache (back/forward), donde el HTML puede ir atrasado. */
  window.addEventListener("pageshow", function (e) { if (e.persisted) recontar(); });
  document.addEventListener("tts:idioma", function () {
    if (aviso) aviso.classList.remove("visible");
  });
})();
